import axios from "axios";

export default {
    async beforeRouteEnter(to, from, next) {
        const res = await axios.get(process.env.VUE_APP_STORAGE_URL + process.env.VUE_APP_SITE_ID + '/meta.json');
        var pageName = to.name
        if( pageName == 'newsDetail' || pageName == 'couponDetail' ){
            var detail = res.data.filter(item => item.name == pageName.replace( /Detail/g , "" ) )
            var route = detail[0].items.filter(item => item.id == to.params.id)
        }else{
            route = res.data.filter(item => item.name == pageName)
        }
        var value = route[0]
        next(() => {
            if (to && value.title) {
                document.title = value.title;
                document
                    .querySelector("meta[property='og:title']")
                    .setAttribute("content", value.title);
            }
            if (to && value.description) {
                document
                    .querySelector("meta[name='description']")
                    .setAttribute("content", value.description);
                document
                    .querySelector("meta[property='og:description']")
                    .setAttribute("content", value.description);
            }
            if (to && value.keywords) {
                document
                    .querySelector("meta[name='keywords']")
                    .setAttribute("content", value.keywords);
            }
        });
	},
};
